import { useState, useEffect } from 'react'
import { checkForRating, ratingLoader, ideaLoader } from '../apiCalls'
import RateActionComp from './rateActionComp'


const RatingComp = (props) => {
    const idea = props.mods.idea

    const [rateToggle, setRateToggle] = useState(false)
    const [currentRating, setCurrentRating] = useState({score: null})
    const [currentAverage, setCurrentAverage] = useState(idea.averageRating)

    //Applies current rating for user
    const getRating = async (ideaId) => {
        let rating = await checkForRating(ideaId)
        if (rating !== null) {
            rating = await ratingLoader(rating._id)
            setCurrentRating({score: rating.score})
        } else {
            rating = null
        }
    }

    //Updates displayed average after user changes their score
    const updateAverage = async (ideaId) => {
        let result = await ideaLoader(ideaId)
        setCurrentAverage(result.averageRating)
    }

    useEffect(() => {
        getRating(idea._id)
    }, [])

    return (
        <div className="ratingDiv">
            {currentAverage === 0 ? <p>Avg Rating: -- / 5</p> : <p>Avg Rating: {currentAverage} / 5</p>}
            <RateActionComp mods={{idea, updateAverage}} />
        </div>
    )
}

export default RatingComp